import { useAppDispatch } from './state'
import {
  getClaimCompanyData as getCategoriesApi,
  searchClaimCompanies as searchRepairersApi
} from '../api/companies'
import {
  setCategories,
  setRadius,
  setRepairers
} from '../state/slices/companies_slice'
import { useCallback } from 'react'
import { IRepairer } from '../api/types/company'

export const useCompanies = () => {
  const dispatch = useAppDispatch()

  const getCategories = useCallback(async () => {
    try {
      const response = await getCategoriesApi()

      if (response.data) {
        dispatch(setCategories(response.data.categories))
        dispatch(setRadius(response.data.radius))
      }

      return true
    } catch (e) {
      return false
    }
  }, [dispatch])

  const searchRepairers = useCallback(async (params: {
    q: string
    radius: number
    category_id: number
    brand_id: number | null
  }) => {
    try {
      const response = await searchRepairersApi(params)

      if (response.data) {
        dispatch(setRepairers(jitterDuplicates(response.data.claimCompanies)))
      }

      return response
    } catch (e) {
      return null
    }
  }, [dispatch])

  const jitterDuplicates = useCallback((items: IRepairer[]) => {
    const seen = new Map<string, number>()

    return items.map((it) => {
      const lat = Number.parseFloat(it.latitude)
      const lng = Number.parseFloat(it.longitude)
      const key = `${lat.toFixed(6)},${lng.toFixed(6)}`
      const n = (seen.get(key) ?? 0) + 1

      seen.set(key, n)

      if (n === 1) return { ...it }

      const offset = 0.00005 * n // ~5m * n

      return { ...it, latitude: String(lat + offset), longitude: String(lng + offset) }
    })
  }, [])

  return {
    getCategories,
    searchRepairers
  }
}

export default useCompanies
